<!-- Loader starts-->
<div class="loader-wrapper" [class.loderhide]="!showLoader">
    <div class="loader bg-white">
      <div class="whirly-loader"> </div>
    </div>
  </div>
  <!-- Loader ends-->
  